import React, { useState, useEffect } from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchSearch, updateAdditionalInfo } from "../../../Redux/Actions/ProfileSteps";
import Multiselect from "multiselect-react-dropdown";
import { useNavigate } from "react-router-dom";
const AdditionalInformation = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isChanged, setIsChanged] = useState({});
    const [prefillData,setPrefillData] = useState({})
  const profileData = useSelector(s => s.ProfileSteps.profileData);
  const skillsSearchResults = useSelector(
    (s) => s.ProfileSteps.searchByField.knownLanguages
  );
  const kids = useSelector((state) => state.dashboard.kids);

  const [formData, setFormData] = useState({});

  const [debouncedSkillsSearch, setDebouncedSkillsSearch] = useState("");
  const [skillsSearch, setSkillsSearch] = useState("");
  const [skillsResults, setSkillsResults] = useState([]);
  useEffect(() => {
  setPrefillData({
    ...profileData,
    languages_known: typeof profileData.languages_known === "string"
      ? profileData.languages_known.split(", ").map(s => s.trim()).filter(Boolean)
      : Array.isArray(profileData.languages_known)
        ? profileData.languages_known
        : [],
  });
}, [profileData]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setIsChanged((prev) => ({ ...prev, [name]: true }));
  };

  const handleSaveAndNext = async() => {
    const hasData = formData && Object.keys(formData).length > 0;

    if (hasData) {
      const updatedFormData = {
        ...formData,
        kid_id: kids?.[0]?.id,
        languages_known: Array.isArray(formData.languages_known)
          ? formData.languages_known
              .map((s) => (typeof s === "string" ? s.trim() : String(s)))
              .filter(Boolean)
              .join(", ")
          : formData.languages_known,
      };

      dispatch(updateAdditionalInfo(updatedFormData));
    } else {
    }
    navigate("/")
  };

  const handleSkillsSelect = (selectedList) => {
    setFormData((prev) => ({ ...prev, languages_known: selectedList }));
  };

  const handleSkillsRemove = (selectedList) => {
    setFormData((prev) => ({ ...prev, languages_known: selectedList }));
  };

  useEffect(() => {
    setSkillsResults(skillsSearchResults || []);
  }, [skillsSearchResults]);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSkillsSearch(skillsSearch), 500);
    return () => clearTimeout(t);
  }, [skillsSearch]);

  useEffect(() => {
    const run = async () => {
      if (debouncedSkillsSearch.length >= 3) {
        try {
          await dispatch(
            fetchSearch({
              search_type: "knownLanguages",
              search_char: debouncedSkillsSearch,
              context: "knownLanguages",
            })
          );
        } catch (err) {
          console.error("Language search failed:", err);
          setSkillsResults([]);
        }
      } else {
        setSkillsResults([]);
      }
    };

    run();
  }, [debouncedSkillsSearch, dispatch]);

const YesNo = ({ name, value }) => (
  <div className="custom-radio-main d-flex gap-4">
    <label className="radio-wrapper form-checkbox radiobox my-3">
      <input
        type="radio"
        name={name}
        className="form-check-input"
        value="true"
        checked={isChanged[name] ? formData[name] === "true" : profileData[name] == true}
        onChange={handleInputChange}
      />
      <span className="checkmark form-check-label">Yes</span>
    </label>
    <label className="radio-wrapper form-checkbox radiobox my-3">
      <input
        type="radio"
        name={name}
        className="form-check-input"
        value="false"
        checked={isChanged[name] ? formData[name] === "false" : profileData[name] == false}
        onChange={handleInputChange}
      />
      <span className="checkmark form-check-label">No</span>
    </label>
  </div>
);

  return (
    <>
      <div className="container-fluid">
        <div className="col-md-8 offset-md-2 py-5">
          <div className="form-bg">
            <div className="form-group">
              <div className="col-lg-12">
                <label>Languages Proficient in</label>

                <Multiselect
                  id="knownLanguages"
                  isObject={false}
                  onRemove={handleSkillsRemove}
                  onSelect={handleSkillsSelect}
                  onSearch={(val) => setSkillsSearch(val)}
                  options={skillsResults?.map((item) => item.object_name) || []}
                  selectedValues={formData.languages_known || prefillData.languages_known || []}
                />
              </div>
            </div>

            <div className="form-group mb-4">
              <label>Driving License</label>
              <YesNo name="has_driving_license" value={formData?.has_driving_license } />
            </div>

            <div className="form-group mb-4">
              <label>2-Wheeler Availability</label>
              <YesNo
                name="has_two_wheeler"
                value={formData.has_two_wheeler}
              />
            </div>

            <div className="form-group mb-4">
              <label>Laptop Availability</label>
              <YesNo name="has_laptop" value={formData.has_laptop} />
            </div>

            <div className="form-group mb-4">
              <label>Smartphone Availability</label>
              <YesNo
                name="has_smartphone"
                value={formData.has_smartphone}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="btn-footer">
        <div className="container-fluid d-flex justify-content-lg-end">
          <button className='default-btn default-border bg-transparent back-btn me-3'><img src="./images/back-arrow.png"  className='d-block d-md-none'/><span className='d-none d-md-block' onClick={() => setCurrentStep(6)}>Back</span></button>
          <button
            className="default-btn default-border bg-transparent me-3"
            onClick={() => setCurrentStep(7)}
          >
            Skip
          </button>
          <button className="default-btn" onClick={handleSaveAndNext}>
            Save & Next
          </button>
        </div>
      </div>
    </>
  );
};

export default AdditionalInformation;
